import {
  ADD_LOAN_REQUEST_REQUEST,
  ADD_LOAN_REQUEST_SUCCESS,
  ADD_LOAN_REQUEST_FAILURE,
  FETCH_LOAN_REQUESTS_REQUEST,
  FETCH_LOAN_REQUESTS_SUCCESS,
  FETCH_LOAN_REQUESTS_FAILURE,
  FETCH_LOAN_REQUEST_DETAILS_REQUEST,
  FETCH_LOAN_REQUEST_DETAILS_SUCCESS,
  FETCH_LOAN_REQUEST_DETAILS_FAILURE,
  UPDATE_LOAN_REQUEST_REQUEST,
  UPDATE_LOAN_REQUEST_SUCCESS,
  UPDATE_LOAN_REQUEST_FAILURE,
  DELETE_LOAN_REQUEST_REQUEST,
  DELETE_LOAN_REQUEST_SUCCESS,
  DELETE_LOAN_REQUEST_FAILURE,
  ADD_APPROVE_REQUEST_REQUEST,
  ADD_APPROVE_REQUEST_SUCCESS,
  ADD_APPROVE_REQUEST_FAILURE,
  ADD_ATTEST_REQUEST_REQUEST,
  ADD_ATTEST_REQUEST_SUCCESS,
  ADD_ATTEST_REQUEST_FAILURE,
  ADD_VERIFY_REQUEST_REQUEST,
  ADD_VERIFY_REQUEST_SUCCESS,
  ADD_VERIFY_REQUEST_FAILURE,
  ADD_REJECT_REQUEST_REQUEST,
  ADD_REJECT_REQUEST_SUCCESS,
  ADD_REJECT_REQUEST_FAILURE,
  ADD_PAY_REQUEST_REQUEST,
  ADD_PAY_REQUEST_SUCCESS,
  ADD_PAY_REQUEST_FAILURE,
  ADD_QUERY_REQUEST_REQUEST,
  ADD_QUERY_REQUEST_SUCCESS,
  ADD_QUERY_REQUEST_FAILURE,
  ADD_COMMENT_REQUEST_REQUEST,
  ADD_COMMENT_REQUEST_SUCCESS,
  ADD_COMMENT_REQUEST_FAILURE,
  SUBMIT_LOAN_REQUEST_REQUEST,
  SUBMIT_LOAN_REQUEST_SUCCESS,
  SUBMIT_LOAN_REQUEST_FAILURE,
  FETCH_LOAN_VOUCHERS_REQUEST,
  FETCH_LOAN_VOUCHERS_SUCCESS,
  FETCH_LOAN_VOUCHERS_FAILURE,
  CLEAR_LOAN_REQUESTS_ERROR,
} from "./loanRequestActionTypes";
import api from "../../api/api";
import { toast } from "react-toastify";

const handleError = (error) => {
  const errorDetails = error.response?.data || error.request || error.message;
  console.error("API Error Details:", errorDetails);
  if (error.response) {
    if (error.response.data?.errors) {
      const validationErrors = Object.values(error.response.data.errors)
        .flat()
        .join("; ");
      return (
        validationErrors ||
        error.response.data?.message ||
        `Error ${error.response.status}: ${error.response.statusText}`
      );
    }
    return (
      error.response.data?.message ||
      `Error ${error.response.status}: ${error.response.statusText}`
    );
  }
  if (error.request) {
    return "No response received from the server. Please try again later.";
  }
  return error.message || "An unknown error occurred.";
};

export const addLoanRequest = (requestData) => async (dispatch) => {
  dispatch({ type: ADD_LOAN_REQUEST_REQUEST });
  const requestBody = {
    userId: requestData.userId,
    requestTypeId: requestData.requestType,
    monthlyRepaymentRate: requestData.monthlyRepaymentRate,
    amount: requestData.amount,
    currency: requestData.currency,
    isOnSaved: requestData.isOnSaved,
    purpose: requestData.purpose || "",
  };
  try {
    console.log("API - addLoanRequest payload:", requestBody);
    const response = await api.post("/Loan", requestBody, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json-patch+json",
        Accept: "*/*",
      },
    });
    console.log("API - addLoanRequest response:", response.data);
    dispatch({ type: ADD_LOAN_REQUEST_SUCCESS, payload: response.data });
    toast.success("Loan Request created successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - addLoanRequest error:", errorMessage);
    dispatch({ type: ADD_LOAN_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const submitLoanRequest = (requestId) => async (dispatch) => {
  dispatch({ type: SUBMIT_LOAN_REQUEST_REQUEST });
  try {
    console.log("API - submitLoanRequest requestId:", requestId);
    const response = await api.post(
      `/Loan/submit/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - submitLoanRequest response:", response.data);
    dispatch({ type: SUBMIT_LOAN_REQUEST_SUCCESS, payload: response.data });
    toast.success("Loan Request submitted successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - submitLoanRequest error:", errorMessage);
    dispatch({ type: SUBMIT_LOAN_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

// export const approveLoanRequest = (requestId) => async (dispatch) => {
//   dispatch({ type: ADD_APPROVE_REQUEST_REQUEST });
//   try {
//     console.log("API - approveLoanRequest requestId:", requestId);
//     const response = await api.post(
//       `/Loan/approve/${requestId}`,
//       {},
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           "Content-Type": "application/json-patch+json",
//           Accept: "*/*",
//         },
//       },
//     );
//     console.log("API - approveLoanRequest response:", response.data);
//     dispatch({ type: ADD_APPROVE_REQUEST_SUCCESS, payload: response.data });
//     toast.success("Loan Request approved successfully");
//     return response.data;
//   } catch (error) {
//     const errorMessage = handleError(error);
//     console.error("API - approveLoanRequest error:", errorMessage);
//     dispatch({ type: ADD_APPROVE_REQUEST_FAILURE, payload: errorMessage });
//     toast.error(errorMessage);
//     throw error;
//   }
// };

export const approveLoanRequest = (requestId, userId) => async (dispatch) => {
  dispatch({ type: ADD_APPROVE_REQUEST_REQUEST });
  try {
    console.log(
      "API - approveLoanRequest requestId:",
      requestId,
      "userId:",
      userId,
    );
    const response = await api.post(
      `/Loan/approve/${requestId}?userId=${userId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - approveLoanRequest response:", response.data);
    dispatch({ type: ADD_APPROVE_REQUEST_SUCCESS, payload: response.data });
    toast.success("Loan Request approved successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - approveLoanRequest error:", errorMessage);
    dispatch({ type: ADD_APPROVE_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const attestLoanRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_ATTEST_REQUEST_REQUEST });
  try {
    console.log("API - attestLoanRequest requestId:", requestId);
    const response = await api.post(
      `/Loan/attest/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - attestLoanRequest response:", response.data);
    dispatch({ type: ADD_ATTEST_REQUEST_SUCCESS, payload: response.data });
    toast.success("Loan Request attested successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - attestLoanRequest error:", errorMessage);
    dispatch({ type: ADD_ATTEST_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const verifyLoanRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_VERIFY_REQUEST_REQUEST });
  try {
    console.log("API - verifyLoanRequest requestId:", requestId);
    const response = await api.post(
      `/Loan/verify/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - verifyLoanRequest response:", response.data);
    dispatch({ type: ADD_VERIFY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Loan Request verified successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - verifyLoanRequest error:", errorMessage);
    dispatch({ type: ADD_VERIFY_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const rejectLoanRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_REJECT_REQUEST_REQUEST });
  try {
    console.log("API - rejectLoanRequest requestId:", requestId);
    const response = await api.post(
      `/Loan/reject/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - rejectLoanRequest response:", response.data);
    dispatch({ type: ADD_REJECT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Loan Request rejected successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - rejectLoanRequest error:", errorMessage);
    dispatch({ type: ADD_REJECT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

// export const payLoanRequest =
//   (requestId, paymentCode, requiresReceipt) => async (dispatch) => {
//     dispatch({ type: ADD_PAY_REQUEST_REQUEST });
//     try {
//       console.log("API - payLoanRequest payload:", {
//         requestId,
//         paymentCode,
//         requiresReceipt,
//       });
//       const response = await api.post(
//         `/Loan/pay`,
//         {
//           requestId,
//           paymentCode,
//           requiresReceipt,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json-patch+json",
//             Accept: "*/*",
//           },
//         },
//       );
//       console.log("API - payLoanRequest response:", response.data);
//       dispatch({ type: ADD_PAY_REQUEST_SUCCESS, payload: response.data });
//       toast.success("Loan Request paid successfully");
//       return response.data;
//     } catch (error) {
//       const errorMessage = handleError(error);
//       console.error("API - payLoanRequest error:", errorMessage);
//       dispatch({ type: ADD_PAY_REQUEST_FAILURE, payload: errorMessage });
//       toast.error(errorMessage);
//       throw error;
//     }
//   };

export const payLoanRequest =
  (requestId, paymentCode, requiresReceipt, userId) => async (dispatch) => {
    dispatch({ type: ADD_PAY_REQUEST_REQUEST });
    try {
      console.log("API - payLoanRequest payload:", {
        requestId,
        paymentCode,
        requiresReceipt,
        userId,
      });
      const response = await api.post(
        `/Loan/pay?userId=${userId}`,
        {
          requestId,
          paymentCode,
          requiresReceipt,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json-patch+json",
            Accept: "*/*",
          },
        },
      );
      console.log("API - payLoanRequest response:", response.data);
      dispatch({ type: ADD_PAY_REQUEST_SUCCESS, payload: response.data });
      toast.success("Loan Request paid successfully");
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - payLoanRequest error:", errorMessage);
      dispatch({ type: ADD_PAY_REQUEST_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      throw error;
    }
  };

export const queryLoanRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_QUERY_REQUEST_REQUEST });
  try {
    console.log("API - queryLoanRequest requestId:", requestId);
    const response = await api.post(
      `/Loan/query/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - queryLoanRequest response:", response.data);
    dispatch({ type: ADD_QUERY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Loan Request queried successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - queryLoanRequest error:", errorMessage);
    dispatch({ type: ADD_QUERY_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const queryLoanRequestComment = (payload) => async (dispatch) => {
  dispatch({ type: ADD_QUERY_REQUEST_REQUEST });
  try {
    console.log("API - queryLoanRequestComment payload:", payload);
    const response = await api.post(`/Loan/query`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json-patch+json",
        Accept: "*/*",
      },
    });
    console.log("API - queryLoanRequestComment response:", response.data);
    dispatch({ type: ADD_QUERY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Query comment submitted successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - queryLoanRequestComment error:", errorMessage);
    dispatch({ type: ADD_QUERY_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const commentLoanRequestReject = (payload) => async (dispatch) => {
  dispatch({ type: ADD_COMMENT_REQUEST_REQUEST });
  try {
    console.log("API - commentLoanRequestReject payload:", payload);
    const response = await api.post(`/Loan/reject`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json-patch+json",
        Accept: "*/*",
      },
    });
    console.log("API - commentLoanRequestReject response:", response.data);
    dispatch({ type: ADD_COMMENT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Request comment submitted successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - commentLoanRequestReject error:", errorMessage);
    dispatch({ type: ADD_COMMENT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  } 
};

export const fetchLoanRequests = () => async (dispatch) => {
  dispatch({ type: FETCH_LOAN_REQUESTS_REQUEST });
  try {
    console.log("API - fetchLoanRequests");
    const response = await api.get("/Loan", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "*/*",
      },
    });
    console.log("API - fetchLoanRequests response:", response.data);
    dispatch({ type: FETCH_LOAN_REQUESTS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - fetchLoanRequests error:", errorMessage);
    dispatch({ type: FETCH_LOAN_REQUESTS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchLoanRequestDetails = (loanId) => async (dispatch) => {
  dispatch({ type: FETCH_LOAN_REQUEST_DETAILS_REQUEST });
  try {
    console.log("API - fetchLoanRequestDetails loanId:", loanId);
    const response = await api.get(`/Loan/${loanId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "*/*",
      },
    });
    console.log("API - fetchLoanRequestDetails response:", response.data);
    dispatch({
      type: FETCH_LOAN_REQUEST_DETAILS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - fetchLoanRequestDetails error:", errorMessage);
    dispatch({
      type: FETCH_LOAN_REQUEST_DETAILS_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};

export const updateLoanRequest =
  (requestId, updatedData) => async (dispatch) => {
    dispatch({ type: UPDATE_LOAN_REQUEST_REQUEST });
    try {
      console.log("API - updateLoanRequest payload:", updatedData);
      const response = await api.put(`/Loan/${requestId}`, updatedData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      });
      console.log("API - updateLoanRequest response:", response.data);
      dispatch({ type: UPDATE_LOAN_REQUEST_SUCCESS, payload: response.data });
      toast.success("Loan Request updated successfully");
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - updateLoanRequest error:", errorMessage);
      dispatch({ type: UPDATE_LOAN_REQUEST_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      throw error;
    }
  };

export const deleteLoanRequest = (requestId) => async (dispatch) => {
  dispatch({ type: DELETE_LOAN_REQUEST_REQUEST });
  try {
    console.log("API - deleteLoanRequest requestId:", requestId);
    await api.delete(`/Loan/${requestId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "*/*",
      },
    });
    console.log("API - deleteLoanRequest success:", requestId);
    dispatch({ type: DELETE_LOAN_REQUEST_SUCCESS, payload: requestId });
    toast.success("Loan Request deleted successfully");
    return requestId;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - deleteLoanRequest error:", errorMessage);
    dispatch({ type: DELETE_LOAN_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchLoanVouchers =
  (voucherId, paymentCode, documentType) => async (dispatch) => {
    dispatch({ type: FETCH_LOAN_VOUCHERS_REQUEST });
    try {
      if (!voucherId || isNaN(voucherId)) {
        throw new Error("Invalid voucherId");
      }
      if (
        !documentType ||
        typeof documentType !== "string" ||
        documentType.trim() === ""
      ) {
        throw new Error("Invalid or missing documentType");
      }
      const cleanDocumentType = documentType.trim();
      const cleanVoucherId = String(voucherId).trim();
      const url = `/Loan/view-voucher/${cleanVoucherId}?documentType=${encodeURIComponent(cleanDocumentType)}`;
      console.log("API - fetchLoanVouchers URL:", url);
      const response = await api.get(url, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "*/*",
        },
      });
      console.log("API - fetchLoanVouchers response:", {
        status: response.status,
        headers: response.headers,
        dataType: response.data.type,
        dataSize: response.data.size,
      });

      if (!response.data || response.data.size === 0) {
        throw new Error("No PDF data received from the server");
      }
      if (response.data.type !== "application/pdf") {
        throw new Error(
          `Invalid response type: expected application/pdf, got ${response.data.type}`,
        );
      }

      const pdfUrl = URL.createObjectURL(response.data);
      const filename =
        response.headers["content-disposition"]?.match(
          /filename=(?:"([^"]+)"|(\S+))/,
        )?.[1] || `Loan_${paymentCode}.pdf`;
      const payload = { url: pdfUrl, filename };

      dispatch({ type: FETCH_LOAN_VOUCHERS_SUCCESS, payload });
      return payload;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - fetchLoanVouchers error:", errorMessage);
      if (error.response?.status === 404) {
        console.warn(
          "API - fetchLoanVouchers: Voucher not found, returning empty payload",
        );
        const payload = { url: null, filename: null };
        dispatch({ type: FETCH_LOAN_VOUCHERS_SUCCESS, payload });
        return payload;
      }
      dispatch({ type: FETCH_LOAN_VOUCHERS_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      throw error;
    }
  };

export const clearLoanRequestsError = () => ({
  type: CLEAR_LOAN_REQUESTS_ERROR,
});
